import React from "react";

const NoExiste = () => {
  return <div>NoExiste</div>;
};

export default NoExiste;
